export const getPIDSize = (skus, size) => {
    const sizeLabel =
        skus?.find((sku) => sku.size.labelSize === size.centralSchemeSizeLabel)?.size.centralSizeLabel ||
        skus?.find((sku) => sku.size.labelSize === size.centralSchemeSizeLabel)?.size.labelSize;
    if (sizeLabel) {
        const sizeLabelArray = sizeLabel.split(' ');
        if (sizeLabelArray.length > 2) {
            return {
                schemaLabel: sizeLabelArray[0],
                sizeLabel: `${sizeLabelArray[1]} ${sizeLabelArray[2]}`,
            };
        } else if (sizeLabelArray.length > 1) {
            return {
                schemaLabel: sizeLabelArray[0],
                sizeLabel: sizeLabelArray[1],
            };
        } else {
            return {
                schemaLabel: '',
                sizeLabel: sizeLabelArray[0],
            };
        }
    } else {
        return {
            schemaLabel: skus?.[0].size?.centralSizeLabel?.split(' ').length > 1 ? skus?.[0].size?.centralSizeLabel?.split(' ')?.[0] : '',
            sizeLabel: size?.centralSchemeSizeLabel,
        };
    }
};

export const toSizeConversion = (sizeChartResponse, skus) => {
    const publicSchemeIndex = sizeChartResponse.centralScheme.publicScheme.reduce((acc, currentValue) => {
        const isNotCN = currentValue.publicSchemeLabel !== 'CN'; // don't want to display China sizes
        if (currentValue.visible !== false && isNotCN) {
            return {
                ...acc,
                [currentValue.id]: currentValue.publicSchemeLabel,
            };
        }
        return acc;
    }, {});

    const sizeConversions = sizeChartResponse.centralScheme.centralSchemeSize.map((size) => {
        const sizes = size.publicSchemeSize.reduce((acc, currentValue) => {
            const schemaLabel = publicSchemeIndex[currentValue.id];
            return schemaLabel
                ? acc.concat({
                      schemaLabel,
                      sizeLabel:
                          currentValue.publicSchemeSizeLabel.length > 1
                              ? `${currentValue.publicSchemeSizeLabel[0]}-${currentValue.publicSchemeSizeLabel[currentValue.publicSchemeSizeLabel.length - 1]}`
                              : currentValue.publicSchemeSizeLabel[0],
                  })
                : acc;
        }, []);

        const preferredlocale = skus?.[0]?.size?.schemas.find((_) => _.selected)?.name;

        const preferredSize = sizes.filter((s) => s.schemaLabel === preferredlocale)?.[0];

        const PIDSize = getPIDSize(skus, size);

        //filter out the preferred size from the size list
        const additionalSizes = sizes.filter((s) => s.schemaLabel !== preferredlocale);
        return {
            centralSize: { schemaLabel: 'INT', sizeLabel: size.centralSchemeSizeLabel },
            sizes: additionalSizes,
            preferredSize: preferredSize ? `${preferredSize.schemaLabel} ${preferredSize.sizeLabel}` : null,
            PIDSize,
        };
    });
    return sizeConversions;
};
